// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import playIcon from "@/assets/icons/play.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type PlayIconProps = Omit<IconProps, "name">;

export function PlayIcon(props: PlayIconProps): React.ReactNode {
  return <Icon name={playIcon} {...props} />;
}
